export { default } from './PatientDiscernTable';
